<template>
  <div class="protocol">
    <header>
      <h1 class="title">服务协议</h1>
    </header>
    <main>
      <p>
        在您开始使用和购买乐享瘦减脂训练营提供的课程服务之前，请您仔细阅读并充分理解《乐享瘦减脂训练营用户协议》(以下简称”本协议”)。
        您确认，您应该具备中华人民共和国法律规定的与您行为相适应的民事行为能力，确保有能力对您使用乐享瘦减脂训练营提供的课程服务的一切行为独立承担责任。
        若您不具备签署与您行为相适应的民事行为能力，请在您的监护人陪同下阅读本协议，并在取得他们对您使用服务的行为以及对本协议全部条款的同意之后，方可使用本服务。
        乐享瘦减脂训练营在依据法律规定或本协议约定要求您承担责任时，有权向您的监护人追偿。
      </p>
      <p>
        <span class="bold-content">
          免除或者限制责任的条款、知识产权条款、法律适用及争议解决等条款将以粗体标识，请您务必重点阅读。
          如果您对本协议的任何条款表示异议，或者无法准确理解本协议，请不要接受乐享瘦减脂训练营的相关课程服务。
          您通过网络页面点击确认、通过第三方软件（包括但不限于微信、小程序或QQ等）授权登录或其他方式选择接受本协议以及您的购买、访问、使用本服务等行为视为对本协议全部内容的接受，
          也意味您将接受本协议以及未来针对本协议更新版本条款的约束，并服从乐享瘦减脂训练营统一管理。
        </span>
      </p>
      <p>
        乐享瘦减脂训练营可能会不定期的更新本协议内容，更新后的协议条款一旦公布即代替原来的协议条款。
        <span class="bold-content">
          协议条款更新后，如您不同意接受更新后的协议，您应停止使用乐享瘦减脂训练营提供的服务。如您继续使用乐享瘦减脂训练营提供的服务的，即视为同意更新后的协议内容。
        </span>
      </p>
      <p>
        本协议是您（以下简称“用户”）与乐享瘦减脂训练营平台（乐享瘦减脂训练营的运营主体为广州乐享瘦健康咨询有限公司，以下简称 “乐享瘦减脂训练营”或我们）之间关于您购买和使用乐享瘦减脂训练营系统课所订立的协议，
        本协议签订地为广州市天河区，本协议仅用于您购买乐享瘦减脂训练营系统课，若您购买乐享瘦减脂训练营的非系统课的课程或者计划，不适用本协议内容。
      </p>
      <br>
      <p>一、课程购买</p>
      <p>1、在您购买乐享瘦减脂训练营系统课（具体系统课名称以购买页面展示为准）之前，您应已经阅读、理解并确认接受本协议的全部内容。您确认在已知悉并确认接受本协议的前提下支付课程费用。</p>
      <p> 2、通过您账号向乐享瘦减脂训练营发生的课程购买行为均视为您本人的真实意思，本协议自乐享瘦减脂训练营收到您支付的课程费用起生效。</p>
      <br>
      <p>二、课程服务</p>
      <p>1、课程内容：系统课课程与服务以购买页面展示的内容为准。系统课附赠的教具教材将在约定的时间内邮寄到您指定的送货地址。
        <span class="bold-content">
          您知悉并同意，前述约定时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估计得出的，乐享瘦减脂训练营不承担附赠教具教材延迟送达的责任。
          您认可，为向您提供更加优质的课程服务，乐享瘦减脂训练营将不断优化、调整课程内容，您购买的课程内容将不时更新优化。
        </span>
      </p>
      <p>2、课程解锁：在您购买乐享瘦减脂训练营系统课开营后，我们将按天解锁乐享瘦减脂训练营系统课的课程内容。</p>
      <p>3、课程有效期：系统课课程购买之后，您可以在课程解锁后随时观看学习课程内容。</p>
      <p>4、社群服务：指乐享瘦减脂训练营为购买本协议项下乐享瘦减脂训练营系统课的用户而建立的微信群或其他形式展现的群体社区，乐享瘦减脂训练营通过群体社区向用户提供特训营系统课答疑、回复咨询、分享学习、互动等课程产品服务，并对社群进行管理。</p>
      <br>
      <p>三、课程费用支付和发票</p>
      <p>1、您可以通过微信、支付宝等方式支付所购买的课程费用，乐享瘦减脂训练营在收到您支付的课程款项后，根据课程安排开通相应的课程服务。</p>
      <p>2、您在付费时可使用代金券/优惠券（如有）进行抵扣，使用后将不再退还。</p>
      <p>
        3、就您向乐享瘦减脂训练营付费购买的课程服务对应的课程费用，您可联系乐享瘦减脂训练营班主任，提供相应的开票信息，申请开具电子普通发票，乐享瘦减脂训练营班主任在核对您提供的开票信息无误后，将向您提供电子普通发票。
        您向乐享瘦减脂训练营代理商付款购买课程服务的，由乐享瘦减脂训练营代理商向您提供发票。
      </p>
      <br>
      <p>四、课程退费和延期</p>
      <p>您向乐享瘦减脂训练营付款购买课程服务的，由乐享瘦减脂训练营执行退费操作；您向乐享瘦减脂训练营代理商付款购买课程服务的，由乐享瘦减脂训练营代理商执行退费操作。</p>
      <p>
        1、您可以通过书面形式联系所购课程的班主任提出退费申请，该款项将按照本协议约定退回您购买乐享瘦减脂训练营系统课时的支付账户，退费到账时间为退费申请受理后15个工作日内。
        乐享瘦减脂训练营将根据系统课官方解锁时间等实际情况进行退费处理，具体方式如下：
      </p>
      <p>
        <span class="bold-content">
          (1) 若您在购买系统课后7个自然日内系统课未经官方解锁，您可以申请无理由退费，
        </span>
        该款项将扣除手续费后原路退回您购买乐享瘦减脂训练营系统课时的支付账户。
      </p>
      <p>
        <span class="bold-content">
          (2) 若您在购买系统课后系统课经官方解锁的，实际退费金额=实际支付金额-手续费（花呗或信用卡等支付方式产生的手续费等）-实际支付金额/课时数*官方已解锁课时数-已寄送的教材教具费用（若有）-赠品费用（如有）-特殊优惠费用（如有），
        </span>
        乐享瘦减脂训练营特殊优惠费用扣除以相应活动规则为准。
      </p>
      <p>(3)注意事项：</p>
      <p>① 课时数=该系统课开营天数</p>
      <p>② 当您在购买系统课后系统课经官方全部解锁的，乐享瘦减脂训练营将不再退还您任何费用。</p>
      <p>③ 在购买之日起七日内(含第七日)已解锁课程，或自购买之日起已超过七日的，若此时您申请退款的乐享瘦减脂训练营将额外扣除您已支付价款金额的10%作为您申请退款的方案费。</p>
      <p>z
        2. 当您选择依据本协议第四条第1款第（2）项向乐享瘦减脂训练营申请课程退费时，您可以选择是否对官方已解锁课时予以保留，
        <span class="bold-content">
          请您注意，您有且仅有一次选择是否保留官方已解锁课时的机会，若您申请退费时未选择保留已解锁课时，在您确认退费后，不得再次提出与此相关的任何要求。
        </span>
      </p>
      <p>
        <span class="bold-content">
          3、您申请退费后，您在购买课程时中获赠的全部课时、优惠等权益将自动取消，不计入退费金额。
        </span>
      </p>
      <p>4、退费申请提交后，您仍可在有效期内反复观看学习在退费前已确认保留的课程内容，但是乐享瘦减脂训练营班主任不再向您提供针对课程的相关服务。</p>
      <p>
        5、您在报名购买乐享瘦减脂训练营系统课后，有且仅有一次延期学习机会，您应当在已购买但未开营或开营的3个自然日内向班主任提出延期学习申请，班主任批准后方可进行延期学习，
        <span class="bold-content">
          发起延期学习后的社群服务应在6个自然月内完成，否则将默认您放弃享受社群服务，只保留听课权限。当您申请延期学习后，视为您已放弃退费申请，您不能再按照本协议约定要求乐享瘦减脂训练营退费。
        </span>
      </p>
      <p>6、您知晓并同意，乐享瘦减脂训练营根据您需求开具发票的，您申请退款后，乐享瘦减脂训练营将对该发票进行作废或红冲处理。</p>
      <p>7、为确保减脂训练营效果，课程应当在限定时间内完成学习（注：限定时间即您购买的服务期天数+365天），未在前述限定期限内完成的，视为您已完成全部课程学习，乐享瘦训练营有权不再提供任何服务和不作任何退费。</p>
      <br>
      <p>
        <span class="bold-content">
          五、知识产权
        </span>
      </p>
      <p>
        <span class="bold-content">
          经由乐享瘦减脂训练营传送的文字、图片、音频、视频及其他内容，受到著作权法、商标法、专利法或其他法律的保护；
          未经乐享瘦减脂训练营书面授权许可，用户不得自行或许可第三方进行复制、转载、传播、修改、售卖、衍生其他作品或者从事其他侵犯乐享瘦减脂训练营知识产权的行为。
          用户购买乐享瘦减脂训练营课程服务的内容仅供用户自己合法使用，用户不得以任何形式，有偿或无偿使得第三方获得内容的全部或部分内容。
          若用户违反协议约定对乐享瘦减脂训练营造成的损失，用户将承担赔偿责任，乐享瘦减脂训练营为维护权益而合理支出的费用（包括但不限于诉讼费、公证费、鉴定费、保全费、保全担保费、律师费等）由用户承担。
        </span>
      </p>
      <br>
      <p>
        <span class="bold-content">
          六、特别声明
        </span>
      </p>
      <p>
        <span class="bold-content">
          1、用户因平台公告之系统停机维护、升级、调整，第三方原因如电信部门的通讯设备故障、计算机病毒或黑客攻击、技术问题、网络、电脑故障、系统不稳定性、
          台风、地震、海啸、洪水、停电、战争、恐怖袭击、政府管制及其他各种不可抗力原因而遭受的一切损失，乐享瘦减脂训练营及其合作单位不承担责任。
        </span>
      </p>
      <p>
        <span class="bold-content">
          2、乐享瘦减脂训练营课程用户账号所有权归乐享瘦减脂训练营所有。
          课程用户账号仅限用户本人使用，禁止赠与、借用、租用、转让或售卖，如果乐享瘦减脂训练营发现使用者并非课程初始购买者，有权不经通知收回账号而无需向账号使用人承担法律责任，由此带来的一切损失由用户自行承担。
        </span>
      </p>
      <p>
        <span class="bold-content">
          3、您同意，我们有权在遵守法律法规的前提下获取、使用、储存和分享您的个人信息。
          我们有权通过cookie等技术收集您的使用、行为信息，并在经过数据脱敏使之后不再指向、关联到您个人的身份信息时，自由使用脱敏后的纯商业数据。
        </span>
      </p>
      <br>
      <p>
        <span class="bold-content">
          七、法律适用及争议解决
        </span>
      </p>
      <p>
        <span class="bold-content">
          1、本协议适用中华人民共和国大陆地区施行的法律。当本协议的任何内容与中华人民共和国法律相抵触时，应当以法律规定为准，同时相关协议将按法律规定进行修改或重新解释，本协议其他部分的法律效力不变。
        </span>
      </p>
      <p>
        <span class="bold-content">
          2、您与乐享瘦减脂训练营关于本协议产生的纠纷，应友好协商，如协商不成的，双方同意将围绕本协议约定产生的纠纷，提交至本协议签订地人民法院即广州市天河区人民法院管辖。
        </span>
      </p>
      <br>
      <p>八、附则</p>
      <p>1、乐享瘦减脂训练营不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响乐享瘦减脂训练营在将来行使该权利。</p>
      <p>2、如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效且具有约束力。</p>
      <p class="datetime" v-if="payTimeStr">日期：{{ payTimeStr }}</p>
    </main>
  </div>
</template>

<script>
export default {
  name: 'protocol_bbk',
  data() {
    return {
      payTime: this.$route.query.pt || '',
      payTimeStr: ''
    };
  },
  created() {
    if (this.payTime) {
      this.payTimeStr = `${this.payTime.substr(0, 4)}年${
        this.payTime.substr(4, 2)}月${
        this.payTime.substr(6, 2)}日`;
    }
  },
  methods: {

  }
};
</script>

<style lang="stylus" scoped>
.protocol {
  padding: 15px 20px;
  width: 100%;
}

.title {
  box-sizing: content-box;
  margin: 0;
  width: auto;
  font-size: 22.5pt;
  font-weight: 800;
  height: 60px;
  padding-top: 30px;
  border-bottom: 1px solid #e7e7e7;
  text-align: center;
}

.datetime {
  margin: 20px 0;
  text-align: right;
}

main {
  width: 100%;

  p {
    font-size: 16px;
    color: #191919;
    line-height: 32px;
    margin-top: 10px;
  }

  .bold-content {
    font-weight: bold;
  }

  h4 {
    padding: 30px 0 15px;
    font-size: 22px;
    font-weight: 900;
    line-height: 36px;
    color: #191919;
  }
}
</style>
